"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractPrimaryCity = void 0;
const extractPrimaryCity = (label) => {
    if (!label)
        return "";
    return label.split(",")[0].trim();
};
exports.extractPrimaryCity = extractPrimaryCity;
